module.exports = __webpack_public_path__ + "static/media/everyday_digital_may_2024.5379bbb5.png";